module.exports = __webpack_public_path__ + "img/Stone Tilt.0bede38c.png";